import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { post } from '../../../redux/api';
import type { ReanalyzeQuickImportRequest } from '../../../../typings/api';

async function reanalyzeQuickImports(): Promise<void> {
  await post<ReanalyzeQuickImportRequest, Record<string, never>>(
    '/api/organizations/reanalyze-quick-imports',
    {},
  );
}

/**
 * Hook to re-analyze all quick-imported projects for the current organization.
 * @returns Mutation function to trigger quick import re-analysis
 */
export const useReanalyzeQuickImports = () => {
  return useToastedMutation({
    mutationFn: reanalyzeQuickImports,
    successToastMessage: 'Quick import re-analysis queued successfully',
    errorToastMessage: 'Failed to queue quick import re-analysis',
  });
};
